import { FC, ReactNode } from 'react';
import { Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() =>
  createStyles({
    typography: {
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 1,
      overflow: 'hidden',
    },
  })
);

/**
 * @summary Элемент для отображения Typography только в одну строку.
 *
 */
export const OneLineTypography: FC<{ children: ReactNode }> = ({ children }) => {
  const { typography } = useStyles();

  return (
    <Typography className={typography} variant="body2">
      {children}
    </Typography>
  );
};
